module.exports = __webpack_public_path__ + "static/media/icon-x.0e999ed2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-x.svg
// module id = ./src/assets/images/icon-x.svg
// module chunks = 0